import { render, staticRenderFns } from "./sanctum_place.vue?vue&type=template&id=0c56ccc5&scoped=true"
import script from "./sanctum_place.vue?vue&type=script&lang=js"
export * from "./sanctum_place.vue?vue&type=script&lang=js"
import style0 from "./sanctum_place.vue?vue&type=style&index=0&id=0c56ccc5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56ccc5",
  null
  
)

export default component.exports